// import { useNavigate } from "react-router-dom";
// import moment from "moment";
// import { cancelSubscription, currentSubscription } from "../api/api";
// import { environment } from "../../environments/environments";
// import { useCallback, useEffect, useState } from "react";
// import "../Subscription/Subscription.css";
// import Swal from "sweetalert2";

// const Subscription = () => {
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(false);
//   const [paymentDetails, setPaymentDetails] = useState([]);
//   const [activePlan, setActivePlan] = useState(null);

//   const fetchPaymentDetails = useCallback(async () => {
//     setLoading(true);
//     try {
//       const userData = localStorage.getItem("currentUser");
//       const parsedUserData = JSON.parse(userData);
//       const userId = parsedUserData?.id || parsedUserData?._id;
//       const response = await currentSubscription({ user_id: userId });
//       if (response?.data?.payment_status === "succeeded") {
//         setActivePlan(response.data);
//       }
//     } catch (error) {
//       console.error("Error fetching subscription:", error);
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchPaymentDetails();
//   }, [fetchPaymentDetails]);

//   const handlePlanPayment = (plan) => {
//     const userData = localStorage.getItem("currentUser");
//     const parsedUserData = JSON.parse(userData);
//     const userId = parsedUserData?.id || parsedUserData?._id;
//     const url = `https://backend.connecttovow.com/subscribe-to/${plan?.id}/${userId}`;
//     navigate("/payment", { state: { paymentUrl: url } });
//   };

//   const cancelSubscriptionFunction = async () => {
//     setLoading(true);
//     try {
//       const userData = localStorage.getItem("currentUser");
//       const parsedUserData = JSON.parse(userData);
//       const userId = parsedUserData?.id || parsedUserData?._id;
//       console.log("cancelSubscripton-userId", userId);
//       const response = await cancelSubscription({ user_id: userId });
//       console.log("cancelSubscripton-api-response", JSON.stringify(response));
//       if (response?.message) {
//         // alert(response.message);
//         Swal.fire({
//           title: "Subscription",
//           text: response.message,
//           icon: "success",
//           confirmButtonColor: "#ff5c5c",
//           confirmButtonText: "OK",
//         });

//         fetchPaymentDetails();
//       }
//     } catch (error) {
//       console.log("Error cancelling subscription", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const renderPlanItem = (plan) => (
//     <div key={plan.id} className="planCard">
//       <div style={{ width: "65%" }}>
//         <h3 className="planName">{plan.name}</h3>
//         <p className="planPrice">
//           {plan.currency_symbol} {plan.price}
//         </p>
//       </div>
//       <button className="payButton" onClick={() => handlePlanPayment(plan)}>
//         <span className="payButtonText">Pay Now</span>
//       </button>
//     </div>
//   );

//   const renderActivePlan = () => (
//     <div className="activePlanCard">
//       <h3
//         className={
//           activePlan.subscription_status === "cancelled"
//             ? "expiredTitle"
//             : "activeTitle"
//         }
//       >
//         {activePlan.subscription_status === "cancelled"
//           ? "Your subscription was cancelled"
//           : "You’re currently subscribed!"}
//       </h3>

//       <div className="row">
//         <span className="label">Plan:</span>
//         <span className="value">{activePlan.product_name}</span>
//       </div>

//       <div className="row">
//         <span className="label">Status:</span>
//         <span
//           className="value"
//           style={{
//             color:
//               activePlan.subscription_status === "cancelled"
//                 ? environment.Coral_Red
//                 : environment.teal,
//             fontWeight: "bold",
//           }}
//         >
//           {activePlan.subscription_status.charAt(0).toUpperCase() +
//             activePlan.subscription_status.slice(1)}
//         </span>
//       </div>

//       <div className="row">
//         <span className="label">Renews On:</span>
//         <span className="value">
//           {moment(activePlan.subscription_expiry_readable).format("MM/DD/YYYY")}
//         </span>
//       </div>

//       <div className="row" style={{ gap: "10px", marginTop: "1.5vh" }}>
//         <button
//           className="cancelSubscriptionBtn"
//           style={{ backgroundColor: environment.teal }}
//           onClick={() =>
//             navigate("/SubscriptionPlans", {
//               state: { counsellingEnabled: "0" },
//             })
//           }
//         >
//           {activePlan?.subscription_status === "cancelled"
//             ? "Subscribe"
//             : "Change Plan"}
//         </button>

//         {activePlan?.subscription_status === "cancelled" ? (
//           <button
//             className="cancelSubscriptionBtn"
//             style={{ backgroundColor: "#d3d3d3" }}
//           >
//             Plan Cancelled
//           </button>
//         ) : (
//           <button
//             className="cancelSubscriptionBtn"
//             onClick={cancelSubscriptionFunction}
//           >
//             Cancel Plan
//           </button>
//         )}
//       </div>
//     </div>
//   );

//   if (loading) {
//     return (
//       //   <div className="loaderContainer">
//       //     <p>Loading...</p>
//       //   </div>
//       <div className="loader"></div>
//     );
//   }

//   return (
//     <div className="subscriptioncontainer">
//       {activePlan ? (
//         renderActivePlan()
//       ) : (
//         <div className="centered">
//           <p className="noActiveText">
//             No active subscription found. Choose a plan below.
//           </p>
//         </div>
//       )}

//       {paymentDetails.length > 0 && (
//         <>
//           <h2 className="mainTitle">Choose a Plan</h2>
//           <div>{paymentDetails.map(renderPlanItem)}</div>
//         </>
//       )}
//     </div>
//   );
// };

// export default Subscription;

import { useNavigate } from "react-router-dom";
import moment from "moment";
import {
  cancelSubscription,
  currentSubscription,
  getActiveSubscription,
  getUserById,
} from "../api/api";
import { environment } from "../../environments/environments";
import { useCallback, useEffect, useState } from "react";
import "../Subscription/Subscription.css";
import Swal from "sweetalert2";

const Subscription = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState([]);
  const [activePlan, setActivePlan] = useState(null);
  const [isSubLoading, setIsSubLoading] = useState(true);
  const [subscription, setsubscription] = useState("");
  const [cancelling, setCancelling] = useState(false);
  const [isFullLoading, setIsFullLoading] = useState(false);
  const [currUserallData, setcurrUserallData] = useState("");

  const fetchPaymentDetails = useCallback(async () => {
    setLoading(true);
    try {
      const userData = localStorage.getItem("currentUser");
      const parsedUserData = JSON.parse(userData);
      const userId = parsedUserData?.id || parsedUserData?._id;
      const response = await currentSubscription({ user_id: userId });
      if (response?.data?.payment_status === "succeeded") {
        setActivePlan(response.data);
      }
    } catch (error) {
      console.error("Error fetching subscription:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPaymentDetails();
    fetchUserData();
  }, [fetchPaymentDetails]);

  const fetchUserData = async () => {
    try {
      // const userData = await AsyncStorage.getItem("currentUser");
      // const parsedUserData = JSON.parse(userData);
      const userData = localStorage.getItem("currentUser");
      const parsedUserData = JSON.parse(userData);
      const _id = parsedUserData?.id || parsedUserData?._id;
      if (_id) {
        const currentUser = await getUserById({ user_id: _id });
        // console.log(
        //   'getUserID by subScription Page',
        //   JSON.stringify(currentUser?.data?.councelling?.name),
        // );
        ActiveSubscription(currentUser?.data?.stripe_customer_id);
        setcurrUserallData(currentUser);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };
  const confirmCancel = () => {
    Swal.fire({
      title: "Cancel Subscription?",
      text: "Your plan will automatically end at the completion of the term. Please note that cancellations are non-refundable.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: environment.Coral_Red,
      cancelButtonColor: environment.teal,
      confirmButtonText: "Yes, Cancel",
      cancelButtonText: "Go Back",
    }).then((result) => {
      if (result.isConfirmed) {
        cancelSubscriptionFunction();
      }
    });
  };
  const handlePlanPayment = (plan) => {
    const userData = localStorage.getItem("currentUser");
    const parsedUserData = JSON.parse(userData);
    const userId = parsedUserData?.id || parsedUserData?._id;
    const url = `https://backend.connecttovow.com/subscribe-to/${plan?.id}/${userId}`;
    navigate("/payment", { state: { paymentUrl: url } });
  };
  const ActiveSubscription = async (customerId) => {
    try {
      if (!customerId) return;
      setIsSubLoading(true);
      // console.log('currentUse_subscription_home', customerId);
      const Subscription = await getActiveSubscription(customerId);
      console.log("Subscriptionblur_page_home", JSON.stringify(Subscription));
      setsubscription(Subscription);
    } catch (error) {
      console.log("ActiveSubscription error", error);
    } finally {
      setIsSubLoading(false);
    }
  };

  // const cancelSubscriptionFunction = async () => {
  //   setLoading(true);
  //   try {
  //     const userData = localStorage.getItem("currentUser");
  //     const parsedUserData = JSON.parse(userData);
  //     const userId = parsedUserData?.id || parsedUserData?._id;
  //     console.log("cancelSubscripton-userId", userId);
  //     // const response = await cancelSubscription({ user_id: userId });
  //     const response = await cancelSubscription(
  //       currUserallData?.data?.stripe_customer_id
  //     );
  //     console.log("cancelSubscripton-api-response", JSON.stringify(response));
  //     if (response?.message) {
  //       // alert(response.message);
  //       Swal.fire({
  //         title: "Subscription",
  //         text: response.message,
  //         icon: "success",
  //         confirmButtonColor: "#ff5c5c",
  //         confirmButtonText: "OK",
  //       });

  //       fetchPaymentDetails();
  //     }
  //   } catch (error) {
  //     console.log("Error cancelling subscription", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const cancelSubscriptionFunction = async () => {
    setLoading(true);
    try {
      const userData = localStorage.getItem("currentUser");
      const parsedUserData = JSON.parse(userData);
      const userId = parsedUserData?.id || parsedUserData?._id;

      const response = await cancelSubscription(
        currUserallData?.data?.stripe_customer_id
      );
      console.log("cancelSubscripton-api-response", JSON.stringify(response));

      if (response?.message) {
        await Swal.fire({
          title: "Subscription",
          text: response.message,
          icon: "success",
          confirmButtonColor: "#e04a48",
          confirmButtonText: "OK",
        });
        window.location.reload();
        // await fetchPaymentDetails();
        // await ActiveSubscription(currUserallData?.data?.stripe_customer_id);

        setActivePlan(null);
        setsubscription("");
        setTimeout(() => {
          fetchPaymentDetails();
          fetchUserData();
        }, 300);
      }
    } catch (error) {
      console.error("Error cancelling subscription", error);
      Swal.fire(
        "Error",
        "Something went wrong. Please try again later.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const renderPlanItem = (plan) => (
    <div key={plan.id} className="planCard">
      <div style={{ width: "65%" }}>
        <h3 className="planName">{plan.name}</h3>
        <p className="planPrice">
          {plan.currency_symbol} {plan.price}
        </p>
      </div>
      <button className="payButton" onClick={() => handlePlanPayment(plan)}>
        <span className="payButtonText">Pay Now</span>
      </button>
    </div>
  );

  const renderActivePlan = () => (
    <div className="activePlanCard">
      <h3
        className={
          // activePlan.subscription_status === "cancelled"
          //   ? "expiredTitle"
          //   : "activeTitle"
          subscription?.subscription?.cancel_at_period_end === true
            ? "expiredTitle"
            : "activeTitle"
        }
      >
        {/* {activePlan.subscription_status === "cancelled"
          ? "Your subscription was cancelled"
          : "You’re currently subscribed!"} */}
        {subscription?.subscription?.cancel_at_period_end === true
          ? "Your subscription was cancelled"
          : "You’re currently subscribed!"}
      </h3>

      <div className="row">
        <span className="label">Plan:</span>
        {/* <span className="value">{activePlan.product_name}</span> */}
        <span className="value">
          {currUserallData?.data?.councelling?.name}
        </span>
      </div>

      <div className="row">
        <span className="label">Status:</span>
        <span
          className="value"
          style={{
            color: subscription?.subscription?.cancel_at_period_end
              ? environment.Coral_Red
              : environment.teal,
            fontWeight: "bold",
          }}
        >
          {/* {activePlan.subscription_status.charAt(0).toUpperCase() +
            activePlan.subscription_status.slice(1)} */}
          {subscription?.subscription?.cancel_at_period_end === true
            ? "Cancelled"
            : "Active"}
        </span>
      </div>

      <div className="row">
        {/* <span className="label">Renews On:</span> */}
        <span className="label">
          {" "}
          {subscription?.subscription?.cancel_at_period_end
            ? "Expires On:"
            : "Renews On:"}
        </span>
        <span className="value">
          {moment(activePlan.subscription_expiry_readable).format("MM/DD/YYYY")}
        </span>
      </div>

      <div className="row" style={{ gap: "10px", marginTop: "1.5vh" }}>
        {/* <button
          className="cancelSubscriptionBtn"
          style={{ backgroundColor: environment.teal }}
          onClick={() =>
            navigate("/SubscriptionPlans", {
              state: { counsellingEnabled: "0" },
            })
          }
        >
          {activePlan?.subscription_status === "cancelled"
            ? "Subscribe"
            : "Change Plan"}
        </button> */}

        {/* {activePlan?.subscription_status === "cancelled" ? (
          <button
            className="cancelSubscriptionBtn"
            style={{ backgroundColor: "#d3d3d3" }}
          >
            Plan Cancelled
          </button>
        ) : (
          <button
            className="cancelSubscriptionBtn"
            // onClick={cancelSubscriptionFunction}
            onClick={confirmCancel}
          >
            Cancel Plan
          </button>
        )} */}

        {activePlan?.subscription_status === "cancelled" ? (
          <button
            className="cancelSubscriptionBtn"
            style={{ backgroundColor: "#d3d3d3" }}
          >
            Plan Cancelled
          </button>
        ) : (
          <button
            className="cancelSubscriptionBtn"
            onClick={async () => {
              if (subscription?.subscription?.cancel_at_period_end) return;

              const result = await Swal.fire({
                title: "Cancel the subscription?",
                text: "Your plan will automatically end at the completion of the term. Please note that cancellations are non-refundable.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, Cancel",
                cancelButtonText: "Go Back",
                reverseButtons: true,
                confirmButtonColor: "#e04a48",
                cancelButtonColor: "#3085d6",
              });

              if (result.isConfirmed) {
                try {
                  await cancelSubscriptionFunction();
                } catch (err) {
                  console.error("Cancel subscription error:", err);
                  Swal.fire(
                    "Error",
                    "Something went wrong. Please try again later.",
                    "error"
                  );
                }
              }
            }}
            disabled={subscription?.subscription?.cancel_at_period_end}
            style={{
              backgroundColor: subscription?.subscription?.cancel_at_period_end
                ? "#e06666ff"
                : environment?.Coral_Red,
            }}
          >
            {subscription?.subscription?.cancel_at_period_end
              ? "Already Cancelled"
              : "Cancel Plan"}
          </button>
        )}
      </div>
    </div>
  );

  if (loading || isSubLoading || isFullLoading) {
    return <div className="loader"></div>;
  }

  return (
    <div className="subscriptioncontainer">
      {
        /*activePlan*/ subscription ? (
          renderActivePlan()
        ) : (
          <div className="centered">
            <p className="noActiveText">
              No active subscription found. Choose a plan below.
            </p>
          </div>
        )
      }

      {paymentDetails.length > 0 && (
        <>
          <h2 className="mainTitle">Choose a Plan</h2>
          <div>{paymentDetails.map(renderPlanItem)}</div>
        </>
      )}
    </div>
  );
};

export default Subscription;
